export class ScreenTitleConfigRequestModel {
    PartitionKey: string = "";
    SortKey: string = "";
    TtlConfigData: string = "";
    ExtraConfig: string = "";
    InsertDate: string = "";
    InsertStfCd: string = "";
    UpdateDate: string = "";
    UpdateStfCd: string = "";
    CorpCd: string = "";
    constructor(
        partitionKey: string = "",
        sortKey: string = "",
        ttlConfigData: string = "",
        ExtraConfig: string = "",
        insertDate: string = "",
        insertStfCd: string = "",
        updateDate: string = "",
        updateStfCd: string = ""
    ) 
    {
        this.PartitionKey = partitionKey;
        this.SortKey = sortKey;
        this.ExtraConfig = ExtraConfig;
        this.TtlConfigData = ttlConfigData;
        this.InsertDate = insertDate;
        this.InsertStfCd = insertStfCd;
        this.UpdateDate = updateDate;
        this.UpdateStfCd = updateStfCd;
    }
}